import { render, staticRenderFns } from "./Article26.vue?vue&type=template&id=9703f764&"
import script from "./Article26.vue?vue&type=script&lang=js&"
export * from "./Article26.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports